<template>
  <div class="backgroud-white cs-accountList-payment">
    <div class="backgroud-gray-popup popup-content-area-small" v-loading="loading">
      <div class="price-detail-area">
        <el-row>
          <el-col>请补充以下换课信息</el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="detail-info">
            <el-row>
              <el-col>
                <span>原课程:</span>
                {{originalCourseName}}
              </el-col>
            </el-row>
            <el-row v-if="changeCourseModel.SelectedDiscount">
              <el-col>
                <span>选择优惠：</span>
                {{changeCourseModel.SelectedDiscount}}
              </el-col>
            </el-row>
            <el-row
              v-if="changeCourseModel.OriginalWorkflowCourse.CourseType==1 || changeCourseModel.OriginalWorkflowCourse.CourseType == 2"
            >
              <el-col>
                <span>类型:</span>
                {{getCourseCategoryText()}}
              </el-col>
            </el-row>
            <el-row v-show="!isOriginalCourseCatetoryNormalClass()">
              <el-col>
                <span>费用类型:</span>
                <span v-if="changeCourseModel.OriginalWorkflowCourse.CourseCategoryId == 2 && changeCourseModel.OriginalWorkflowCourse.VipCoursePriceId">{{getVipCoursePriceDescription()}}</span>
                <span v-else>{{getCourseCategoryOptionText()}}</span>
              </el-col>
            </el-row>
            <el-row
              v-show="isOriginalCourseHourPrice() || changeCourseModel.OriginalWorkflowCourse.IsHourPrice || changeCourseModel.OriginalWorkflowCourse.CourseCategoryId == 2"
            >
              <el-col>
                <span>时长:</span>
                {{changeCourseModel.OriginalWorkflowCourse.CourseCount}}小时
                {{changeCourseModel.OriginalWorkflowCourse.CourseMinutes}}分钟
              </el-col>
            </el-row>
             <el-row
              v-if="changeCourseModel.OriginalWorkflowCourse.YearCourseType > 0"
            >
              <el-col>
                <span>年课学期:</span>
                {{getYearCourseTypeText(changeCourseModel.OriginalWorkflowCourse.YearCourseType)}}
              </el-col>
            </el-row>
            <el-row
              v-if="changeCourseModel.OriginalWorkflowCourse.CourseType==GLOBAL.courseType.university && isOriginalCourseCatetoryNormalClass()"
            >
              <el-col>
                <span>开始周期:</span>
                {{changeCourseModel.OriginalCourseStartWeekText}}
              </el-col>
            </el-row>
            <el-row
              v-if="changeCourseModel.OriginalWorkflowCourse.CourseType==GLOBAL.courseType.university  && isOriginalCourseCatetoryNormalClass()"
            >
              <el-col>
                <span>视频机制:</span>
                {{changeCourseModel.OriginalWorkflowCourse.SupplementVideoTypeText}}
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <span>折后小计:</span>
                {{changeCourseModel.OriginalWorkflowCourse.PaymentDiscountPrice}}
              </el-col>
            </el-row>
            <el-row
              v-show="isShowAfterWeek2 || changeCourseModel.OriginalWorkflowCourse.CourseType!=GLOBAL.courseType.university"
            >
              <el-col>
                <span>已上课时:</span>
                <el-input-number
                  v-model="changeCourseModel.SignedInTimeLength"
                  :precision="1"
                  :disabled="isCalculated || isCalculating"
                  :step="1"
                  :max="100"
                  :min="0"
                  size="mini"
                ></el-input-number>
                <span>小时</span>
              </el-col>
            </el-row>
            <el-row
              v-show="isShowAfterWeek2 || changeCourseModel.OriginalWorkflowCourse.CourseType!=GLOBAL.courseType.university"
            >
              <el-col>
                <span>课时单价:</span>
                {{changeCourseModel.OriginalCourseRefundPrice}}
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <span>原课节余:</span>
                {{changeCourseModel.OriginalWorkflowCourse.PaymentDiscountPrice - changeCourseModel.SignedInTimeLength*changeCourseModel.OriginalCourseRefundPrice}}
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" class="detail-info">
            <el-row>
              <el-col>
                <span>新课程：</span>
                <el-select
                  filterable
                  :disabled="isCalculated || isCalculating"
                  v-model="selectedCourseId"
                  @change="onNewCourseChange"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="item in courseList"
                    :disabled="!!item.Disabled && !item.IsYearCourse"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row
              v-if="changeCourseModel.OriginalWorkflowCourse.CourseType==GLOBAL.courseType.university"
            >
              <el-col>
                <span>类型:</span>
                <el-select
                  :disabled="isCalculated || isCalculating"
                  v-model="changeCourseModel.NewCourseWorkflowCourse.CourseCategoryId"
                  @change="onNewCourseCategoryChanged"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="item in this.universityCourseCategoryList"
                    :key="item.Id"
                    :label="item.Label"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row
              v-show="changeCourseModel.OriginalWorkflowCourse.CourseType==GLOBAL.courseType.university && !this.changeCourseModel.IsNormalClass"
            >
              <el-col>
                <span>费用类型:</span>
                <el-select v-if="isVip" :disabled="isCalculated || isCalculating" size="mini" v-model="changeCourseModel.NewCourseWorkflowCourse.VipCoursePriceId" placeholder="请选择费用类型" @change="onNewCourseVipCoursePriceChange">
                  <el-option v-for="item in dataIn.vipCoursePrices" :key="item.Id" :label="item.Description" :value="item.Id">
                  </el-option>
                </el-select>
                <el-select
                  v-else
                  :disabled="isCalculated || isCalculating"
                  v-model="changeCourseModel.NewCourseWorkflowCourse.CourseCategoryOptionId"
                  @change="onNewCourseCategoryOptionChanged"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="item in this.categoryOptionList"
                    :key="item.Id"
                    :label="item.Label"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row v-if="isNewCourseHourPrice || isVip">
              <el-col>
                <span>时长:</span>
                <div class="cs-courseEnrollmentDetail-number-container">
                  <el-input-number
                    :disabled="isCalculated || isCalculating"
                    @change="onNewCourseCourseCountChange"
                    :step="hourStep"
                    size="mini"
                    v-model="changeCourseModel.NewCourseWorkflowCourse.CourseCount"
                    :min="0"
                    :max="100"
                    label="小时数"
                  ></el-input-number>
                </div>
                <div class="cs-courseEnrollmentDetail-number-container">
                  <el-input-number :disabled="isCalculated || isCalculating" size="mini" v-model="changeCourseModel.NewCourseWorkflowCourse.CourseMinutes" @change="onNewCourseMinutesChange" :step="1" :min="0" :max="60"
                    label="分钟数"></el-input-number>
                </div>
              </el-col>
            </el-row>
             <el-row v-if="changeCourseModel.OriginalWorkflowCourse.CourseType==GLOBAL.courseType.university && this.changeCourseModel.IsNormalClass && isYearCourse">
              <el-col>
                <span>年课学期:</span>
                <el-select
                    :disabled="isCalculated || isCalculating"
                    size="small"
                    v-model="changeCourseModel.NewCourseWorkflowCourse.YearCourseType"
                    placeholder="请选择年课学期"
                    @change="onYearCourseTypeChange"
                  >
                    <el-option
                      v-for="item in yearCourseTypeList"
                      :key="item.Value"
                      :label="item.Text"
                      :value="item.Value"
                    >
                    </el-option>
                  </el-select>
              </el-col>
            </el-row>
            <el-row
              v-if="changeCourseModel.OriginalWorkflowCourse.CourseType==GLOBAL.courseType.university && this.changeCourseModel.IsNormalClass"
            >
              <el-col>
                <span>开始周期:</span>
                <el-select
                    v-if="isYearCourse"
                    :disabled="isCalculated || isCalculating"
                    @change="onStartWeekChange"
                    v-model="changeCourseModel.NewCourseWorkflowCourse.StartWeek"
                    placeholder="请选择"
                    size="mini"
                  >
                    <el-option
                      v-for="item in yearCourseWeekList"
                      :key="item.Week"
                      :label="item.Label"
                      :value="item.Week"
                    >
                    </el-option>
                  </el-select>
                <el-select
                  v-else
                  :disabled="isCalculated || isCalculating"
                  @change="onStartWeekChange"
                  v-model="changeCourseModel.NewCourseWorkflowCourse.StartWeek"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="item in changeCourseModel.TermNormalWeekList"
                    :key="item.Week"
                    :label="item.Label"
                    :value="item.Week"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row
              v-show="changeCourseModel.OriginalWorkflowCourse.CourseType==GLOBAL.courseType.university && this.changeCourseModel.IsNormalClass"
            >
              <el-col>
                <span>视频机制:</span>
                <el-checkbox v-if="isOnlineCourse" :disabled="isCalculated || isCalculating" v-model="isOnlineCourseVideoFree" @change="onOnlineCourseVideoFreeChange">可以观看报名节点前视频</el-checkbox>
                <el-select
                  v-else
                  :disabled="isCalculated || isCalculating"
                  v-model="changeCourseModel.NewCourseWorkflowCourse.SupplementVideoType"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="item in supplementVideoTypeList"
                    :key="item.Key"
                    :label="item.Value"
                    :value="item.Key"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>

            <el-row>
              <el-col>
                <span></span>
                <el-checkbox
                  :disabled="isCalculated || isCalculating"
                  v-model="changeCourseModel.IsUseDiscount"
                >是否应用优惠</el-checkbox>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <span>折后小计:</span>
                {{newPrice}}
              </el-col>
            </el-row>
            <el-row v-if="workflowRelatedDicountAmount != 0">
              <el-col>
                <span>课程连报差价:</span>
                {{workflowRelatedDicountAmount}}
              </el-col>
            </el-row>
             <el-row v-if="workflowRelatedDicountAmount != 0">
              <el-col>
                <span>合计:</span>
                {{newCourseTotalPrice}}
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div v-show="isCalculated" class="price-result-area">
        <el-row class="summary">
          <el-col>
            <div>
              <div>
                <span v-if="changeCourseType == 1">
                  <span>经计算，需要向学生</span>
                  <span class="remark">收取</span>
                  <span>差价：{{priceDiff}}</span>
                </span>
                <span v-else-if="changeCourseType == 2">
                  <span>经计算，需要向学生</span>
                  <span class="remark">退还</span>
                  <span>差价：{{priceDiff}}</span>
                </span>
                <span v-else-if="changeCourseType == 0">
                  <span>经计算，</span>
                  <span class="remark">未产生</span>
                  <span>任何差价</span>
                </span>
              </div>
              <div v-if="changeCourseModel.HasVideoPackage">
                <span>注: 原课程已买视频包，视频包将</span>
                <span v-if="changeCourseModel.NewCourseWorkflowCourse.CourseCategoryId === GLOBAL.enumNormalCourseCategory.OfflineCourse" class="remark">自动转移</span>
                <span v-else class="remark">自动退款</span>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="payment-info" v-if="changeCourseType == 1">
        <el-row>
          <el-col :span="6" :offset="6">
             <span>使用现金减:</span>
          </el-col>
          <el-col :span="12" class="payment-info-content">
            <el-input
              @change="onCashDecreasedAmountChange"
              size="mini"
              v-model="changeCourseModel.NewCourseWorkflowCourse.CashDecreasedAmount"
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" :offset="6">
             <span>当前积分:</span>
          </el-col>
          <el-col :span="12"  class="payment-info-content" v-if="memberModel.IsMember">
            {{memberModel.BonusPoint}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" :offset="6">
             <span>使用积分:</span>
          </el-col>
          <el-col :span="12" class="payment-info-content" v-if="memberModel.IsMember">
            <el-input
              @change="onBonusPointCostChange"
              size="mini"
              v-model="changeCourseModel.NewCourseWorkflowCourse.BonusPointCost"
            ></el-input>
            {{bonusPointAmount | toCurrency}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" :offset="6">
             <span>最终差价:</span>
          </el-col>
          <el-col :span="12" class="payment-info-content">
            <span class="cs-redLabel">{{finalPrice + finalPriceTax | toCurrency}}</span>
            <span v-if="finalPriceTax > 0" class="cs-redLabel">(含税 {{finalPriceTax | toCurrency}})</span>
          </el-col>
        </el-row>
        </div>
        <div class="detail">
          <hr />
          <el-row v-show="refundDetailVisible">
            <el-col :span="3">
              <span>原支付方式：</span>
            </el-col>
            <el-col :span="5">
              <div>现金/转帐</div>
              <div>{{refundDetailModel.IncomeInFact | toCurrency}}</div>
            </el-col>
            <el-col :span="5">
              <div>旧余额</div>
              <div>{{refundDetailModel.OldBalanceCost | toCurrency}}</div>
            </el-col>
            <el-col :span="5">
              <div>新余额</div>
              <div>{{refundDetailModel.NewBalanceCost| toCurrency}}</div>
            </el-col>
            <el-col :span="5">
              <div>赠送余额</div>
              <div>{{refundDetailModel.GiftBalanceCost| toCurrency}}</div>
            </el-col>
          </el-row>
          <el-row v-show="refundDetailVisible" class="margin-top-10">
            <el-col :span="3">
              &nbsp;
            </el-col>
            <el-col :span="5">
              <div>占位</div>
              <div>{{refundDetailModel.AdvanceEnrollmentCost| toCurrency}}</div>
            </el-col>
            <el-col :span="5">
              <div>积分</div>
              <div>{{refundDetailModel.BonusPointCost}}</div>
            </el-col>
            <el-col :span="5">
              <div>代金券</div>
              <div>{{refundDetailModel.CashDecreasedAmount| toCurrency}}</div>
            </el-col>
            <el-col :span="5">
              <div>优惠券</div>
              <div>{{refundDetailModel.CouponDiscountDollar| toCurrency}}</div>
            </el-col>
          </el-row>
          <el-row v-show="refundDetailVisible">
            <el-col :span="4">
              <span>退款方案：</span>
            </el-col>
            <el-col :span="20">
              <el-row>
                <el-col :span="24">
                  <span>课程剩余金额：{{(priceDiff) | toCurrency}}, </span>
                  <span>减欠款 {{(refundDetailModel.DecreaseDebt) | toCurrency}},</span>
                  <span v-if="refundDetailModel.CashDecreasedAmount != 0">减现金减 {{(refundDetailModel.CashDecreasedAmount) | toCurrency}},</span>
                  <span v-if="refundDetailModel.CouponDiscountDollar != 0">减优惠劵 {{(refundDetailModel.CouponDiscountDollar) | toCurrency}},</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span v-if="bonusPointIncrease != 0">退还积分：{{bonusPointIncrease}}({{bonusPointIncreaseAmount | toCurrency}}),</span>
                  <span v-if="bonusPointDescrease != 0">扣除积分：-{{bonusPointDescrease}},</span>
                  <br v-if="bonusPointIncrease != 0 || bonusPointDescrease != 0"/>
                  <span>退还旧余额：{{refundResult.RefundOldBalance + refundResult.RefundOldBalanceTax | toCurrency}}<span v-if="refundResult.RefundOldBalanceTax > 0">(含退税 {{refundResult.RefundOldBalanceTax| toCurrency}})</span>,</span>
                  <span>退还新余额：{{refundResult.RefundNewBalance + refundResult.RefundNewBalanceTax | toCurrency}}<span v-if="refundResult.RefundNewBalanceTax > 0">(含退税 {{refundResult.RefundNewBalanceTax| toCurrency}})</span>,</span>
                  <span>退还赠送余额：{{refundResult.RefundGiftBalance + refundResult.RefundGiftBalanceTax | toCurrency}}<span v-if="refundResult.RefundGiftBalanceTax > 0">(含退税 {{refundResult.RefundGiftBalanceTax| toCurrency}})</span></span>
                  <br v-if="bonusPointDescreaseNotEnough != 0"/>
                  <span
                    v-if="bonusPointDescreaseNotEnough != 0"
                  >(扣除积分-{{bonusPointDescreaseNotEnough}}, 对应金额：-{{bonusPointDescreaseNotEnoughPrice | toCurrency}})</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="12" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col :span="12" class="footer-right">
          <el-button
            :loading="isCalculating"
            :disabled="isSaving"
            type="primary"
            @click="calculate()"
          >{{isCalculated?"重新计算":"计算差价"}}</el-button>
          <el-button
            :disabled="!isCalculated"
            :loading="isSaving"
            type="success"
            @click="saveCourse()"
          >确认换课</el-button>
          <el-button type="info" @click="cancelSave()">取消</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-accountList-payment {
  span {
    display: inline-block;
    margin-right: 1px;
  }

  img {
    display: inline-block;
    width: 20px;
    margin-right: 5px;
    margin-left: 5px;
  }

  .price-detail-area {
    min-height: 300px;

    div {
      height: 33px;
    }

    .detail-info {
      span {
        width: 100px;
      }
    }

    .cs-courseEnrollmentDetail-number-container{
      display: inline-block;
      margin-left: 5px;

      /deep/ .el-input-number--mini{
        width: 100px;
      }
      
      &:first-of-type{
        margin-left: 0;
      }
    }
    
  }

  .price-result-area {
    .summary {
      margin-top: 20px;
      text-align: center;
      width: 100%;

      .remark {
        color: red;
        font-weight: bold;
      }
    }

    .payment-info {
      text-align: center;
      margin-top: 10px;

      span {
        display: inline-block;
        width: 80px;
      }
      .el-input {
        width: 120px;
        display: inline-block;
      }
      .el-row{
        margin-top: 10px;
      }
      .payment-info-content{
        text-align: left;
      }
    }
  }
}
</style>

<script>
import {
  saveCourseChange,
  getChangeCourseModel,
  getRefundDetail,
  calculateChangeCourseEnrollmentFee
} from "../../service/finance.service.js";
import { getSupplementVideoTypeList } from "../../service/common.service";
import { getBonusPointMechanismByType } from "../../service/bonusPoint.service";
import { getStudentMemberInfo } from "../../service/student.service";
import {getYearCourseType, toDecimal} from "../../config/mUtils"

export default {
  props: {
    courseType: Number,
    dataIn: {
      salesQueryRow: Object,
      courseCategoryList: [],
      week: Number,
      supplementVideoType: Number,
      vipCoursePrices: Array
    }
  },
  data() {
    return {
      bonusPointIncrease: 0,
      bonusPointIncreaseAmount: 0,
      bonusPointDescrease: 0,
      bonusPointDescreaseNotEnough: 0, //不足积分
      bonusPointDescreaseNotEnoughPrice: 0, //积分不足扣除金额
      moneyToBonusPoint: {},
      bonusPointToMoney: {},
      hourStep: 1,
      courseList: [],
      selectedCourseId: "",
      selectedCourseName: "",
      excludeCourseIdList: [],
      isEditing: false,
      originalCourseName: "",
      refundDetailVisible: false,
      isVip: false,
      changeCourseModel: {
        IsNormalClass: true,
        IsUseDiscount: false,
        OriginalWorkflowCourse: {},
        NewCourseWorkflowCourse: {}
      },
      isNewCourseHourPrice: false,
      isCalculated: false,
      isCalculating: false,
      isShowAfterWeek2: false,
      isSaving: false,
      showError: false,
      errorMessage: "",
      newPrice: "待计算",
      workflowRelatedDicountAmount: 0,
      courseCategoryList: [],
      universityCourseCategoryList: [],
      categoryOptionList: [],
      refundResult: {
        RefundBonusPoint: 0,
        RefundBalance: 0,
        RefundOldBalance: 0,
        RefundNewBalance: 0,
        RefundGiftBalance: 0,
        RefundOldBalanceTax: 0,
        RefundNewBalanceTax: 0,
        RefundGiftBalanceTax: 0,
        DecreaseDebt: 0
      },
      refundDetailModel: {},
      supplementVideoTypeList: [],
      memberModel: {},
      yearCourseTypeAllList:[],
      yearCourseTypeList:[],
      yearCourseWeekList:[],
      isYearCourse: false,
      loading: false,
      isOnlineCourseVideoFree: false
    };
  },
  components: {},
  created() {
    this.yearCourseTypeAllList = getYearCourseType();
    getBonusPointMechanismByType(1).then(result => {
      if (result && result.success) {
        this.moneyToBonusPoint = result.data;
      }
    });
    getBonusPointMechanismByType(2).then(result => {
      if (result && result.success) {
        this.bonusPointToMoney = result.data;
      }
    });
    getSupplementVideoTypeList().then(result => {
      if (result && result.success) {
        this.supplementVideoTypeList = result.data;
      }
    });
    this.init();
  },
  computed: {
    newCourseTotalPrice: function(){
      return this.changeCourseModel.NewCourseWorkflowCourse.PaymentDiscountPrice + this.changeCourseModel.WorkflowRelatedDicountAmount;
    },
    changeCourseType: function(){
      //补差价
      if (this.newCourseTotalPrice > this.changeCourseModel.OriginalCourseLeftMoney){
        return 1;
      } 
      //退差价
      else if (this.newCourseTotalPrice < this.changeCourseModel.OriginalCourseLeftMoney){
        return 2;
      } 
      //无差价
      else{
        return 0;
      }
    },
    priceDiff: function(){
      if (this.changeCourseType == 1){
        return toDecimal(this.newCourseTotalPrice - this.changeCourseModel.OriginalCourseLeftMoney);
      } else if (this.changeCourseType == 2){
        return toDecimal(this.changeCourseModel.OriginalCourseLeftMoney - this.newCourseTotalPrice);
      }
      return 0;
    },
    bonusPointAmount: function() {
      return (
        (this.changeCourseModel.NewCourseWorkflowCourse.BonusPointCost *
          this.bonusPointToMoney.Money) /
        this.bonusPointToMoney.BonusPoint
      );
    },
    finalPrice: function() {
      return (
        this.newCourseTotalPrice -
        this.changeCourseModel.OriginalCourseLeftMoney -
        this.changeCourseModel.NewCourseWorkflowCourse.CashDecreasedAmount -
        this.bonusPointAmount
      );
    },
    finalPriceTax: function(){
      if (this.changeCourseType == 1){
    
        if (this.changeCourseModel.HasTax){
          return this.finalPrice * this.changeCourseModel.TaxRate;
        }
      }
      return 0;
    },
    isOnlineCourse: function(){
      let isOnline = this.changeCourseModel.NewCourseWorkflowCourse.CourseCategoryId === this.GLOBAL.enumNormalCourseCategory.OnlineCourse
        || this.changeCourseModel.NewCourseWorkflowCourse.CourseCategoryId === this.GLOBAL.enumNormalCourseCategory.OMO;
      return isOnline;
    }
  },
  methods: {
    init() {
      this.excludeCourseIdList = this.dataIn.salesQueryRow.ExcludeCourseIds
        ? this.dataIn.salesQueryRow.ExcludeCourseIds.split(",")
        : [];
      this.courseCategoryList = this.dataIn.courseCategoryList;
      this.universityCourseCategoryList = this.dataIn.courseCategoryList[
        this.courseType
      ];
      this.isCalculated = false;
      this.loadChangeCourseData();
      this.newPrice = "待计算";
      this.workflowRelatedDicountAmount = 0;
      if (this.courseType == 2) {
        this.hourStep = 2;
      }
      getStudentMemberInfo(this.dataIn.salesQueryRow.StudentId, "").then(result => {
        if (result && result.success) {
          this.memberModel = result.data;
        }
      });
    },
    loadYearCourseTypeList(isReset){
      this.yearCourseTypeList = [];
    
      if (this.isYearCourse){
        let course = this.courseList.find(i => i.Id == this.selectedCourseId);
        let keys = Object.keys(course.YearCourseTypeWithWeek);
        this.yearCourseTypeAllList.forEach(i =>{
          if (keys.indexOf(i.Value.toString()) >= 0){
            this.yearCourseTypeList.push(i);
          }
        });
        if (this.yearCourseTypeList.length > 0 && isReset){
          this.changeCourseModel.NewCourseWorkflowCourse.YearCourseType = this.yearCourseTypeList[0].Value;
        }
        this.loadYearCourseWeekList(isReset);
      }else{
        if (isReset){
          this.setCurrentWeek();
        }
      }
    },
    loadYearCourseWeekList(isResetWeek){
      let course = this.courseList.find(i => i.Id == this.selectedCourseId);
      if (this.isYearCourse){
        let yearCourseType = this.changeCourseModel.NewCourseWorkflowCourse.YearCourseType;
        if (!!course.YearCourseTypeWithWeek[yearCourseType]){
          this.yearCourseWeekList = course.YearCourseTypeWithWeek[yearCourseType];
        }else{
          this.yearCourseWeekList = [];
        }
      }else{
         this.yearCourseWeekList = []; 
      }

      if (isResetWeek){
        this.setCurrentWeek();
      }
    },
    setCurrentWeek(){
      let week = 1;
      let list = null;
      if (this.isYearCourse){
        list = this.yearCourseWeekList;
      }else{
        list = this.changeCourseModel.TermNormalWeekList;
      }
      let currentWeekObj = list.find(i => i.IsCurrent);
      if (!!currentWeekObj){
        week = currentWeekObj.Week;
      }else{
        if (list.length > 0){
          week = list[0].Week;
        }
      }
      this.changeCourseModel.NewCourseWorkflowCourse.StartWeek = week;
    },
    getYearCourseTypeText(type){
      let item = this.yearCourseTypeAllList.find(i => i.Value == type);
      if (!!item){
        return item.Text;
      }
      return "";
    },
    onBonusPointCostChange() {},
    onCashDecreasedAmountChange() {},
    excludeCourse() {
      let self = this;
      this.excludeCourseIdList.forEach(excludeId => {
        let course = self.courseList.filter(p => p.Id == excludeId)[0];
        if (!!course && course.Id > 0) {
          course.Disabled = true;
        }
      });

    },
    getCourseCategoryText() {
      let result = this.universityCourseCategoryList.filter(
        i =>
          i.Id == this.changeCourseModel.OriginalWorkflowCourse.CourseCategoryId
      );
      if (result.length > 0) {
        return result[0].Label;
      }
      return "";
    },
    getOriginalCourseName() {
      let result = this.courseList.filter(
        i => i.Id == this.changeCourseModel.OriginalWorkflowCourse.CourseId
      );
      if (result.length > 0) {
        this.$set(this, "originalCourseName", result[0].Name);
      } else this.$set(this, "originalCourseName", "");
    },
    getVipCoursePriceDescription(){
      let desc = "";
      let result = this.dataIn.vipCoursePrices.find(
        (i) => i.Id == this.changeCourseModel.OriginalWorkflowCourse.VipCoursePriceId
      );
      if (result){
        desc = result.Description;
      }
      return desc;
    },
    getCourseCategoryOptionText() {
      let result = this.universityCourseCategoryList.filter(
        i =>
          i.Id == this.changeCourseModel.OriginalWorkflowCourse.CourseCategoryId
      );
      if (result.length > 0) {
        let option = result[0].CourseCategoryOptionsList.filter(
          j =>
            j.Id ==
            this.changeCourseModel.OriginalWorkflowCourse.CourseCategoryOptionId
        );
        if (option.length > 0) return option[0].Label;
      }
      return "";
    },
    isOriginalCourseCatetoryNormalClass() {
      if (
        this.changeCourseModel.OriginalWorkflowCourse.CourseType == 2 ||
        this.changeCourseModel.OriginalWorkflowCourse.CourseType == 3
      ) {
        return true;
      }
      let categoryId = this.changeCourseModel.OriginalWorkflowCourse.CourseCategoryId;
      let category = this.universityCourseCategoryList.filter(i =>i.Id == categoryId);
      if (category.length > 0) {
        return this.getIsNormalClass(categoryId);
      } else {
        return false;
      }
    },
    isOriginalCourseHourPrice() {
      let isHour = false;
      let result = this.universityCourseCategoryList.filter(
        i =>
          i.Id == this.changeCourseModel.OriginalWorkflowCourse.CourseCategoryId
      );
      if (result.length > 0) {
        let option = result[0].CourseCategoryOptionsList.filter(
          j =>
            j.Id ==
            this.changeCourseModel.OriginalWorkflowCourse.CourseCategoryOptionId
        );
        if (option.length > 0) {
          isHour = option[0].IsHourPrice;
        }
      }
      return isHour;
    },
    checkForNewCourseHourPrice() {
      let isHour = false;
      if (this.courseType == 1) {
        let result = this.universityCourseCategoryList.filter(
          i =>
            i.Id ==
            this.changeCourseModel.NewCourseWorkflowCourse.CourseCategoryId
        );
        if (result.length > 0) {
          let option = result[0].CourseCategoryOptionsList.filter(
            j =>
              j.Id ==
              this.changeCourseModel.NewCourseWorkflowCourse
                .CourseCategoryOptionId
          );
          if (option.length > 0) {
            isHour = option[0].IsHourPrice;
          }
        }
      } else if (this.courseType == 2) {
        let course = this.courseList.find(i => i.Id == this.selectedCourseId);

        if (!!course) {
          isHour = course.IsHourPrice;
        }
      }

      this.isNewCourseHourPrice = isHour;
    },
    checkForNewCourseYearCourse(){
      let course = this.courseList.find(i => i.Id == this.selectedCourseId);
      if (course){
        this.isYearCourse = course.IsYearCourse;
      }else{
        this.isYearCourse = false;
      }
    },
    onNewCourseChange() {
      this.checkForNewCourseHourPrice();
      this.checkForNewCourseYearCourse();
      this.loadYearCourseTypeList(true);
      if (this.courseType === this.GLOBAL.courseType.university) {
        let isNormalClass = this.getIsNormalClass(this.changeCourseModel.OriginalWorkflowCourse.CourseCategoryId);
        if (isNormalClass){
          let course = this.courseList.find(i => i.Id == this.selectedCourseId);
          this.changeCourseModel.NewCourseWorkflowCourse.CourseCategoryId = course.CourseCategory;
          this.onNewCourseCategoryChanged();
        }
      }
    },
    onNewCourseCategoryChanged() {
      if (this.courseType === this.GLOBAL.courseType.university) {
        let newCourse = this.changeCourseModel.NewCourseWorkflowCourse;
        let categoryId = newCourse.CourseCategoryId;
        let category = this.universityCourseCategoryList.filter(i => i.Id == categoryId);
        if (category.length > 0) {
          let isNormalClass = this.getIsNormalClass(categoryId);
          if (isNormalClass) {
            this.changeCourseModel.IsNormalClass = true;
            newCourse.CourseCategoryOptionId = null;
            newCourse.VipCoursePriceId = null;
            this.isVip = false;
          } else {
            if (categoryId === this.GLOBAL.enumNormalCourseCategory.Vip){
              this.isVip = true;
              if (!newCourse.VipCoursePriceId){
                newCourse.VipCoursePriceId = this.dataIn.vipCoursePrices[0].Id;
              }
              newCourse.CourseCategoryOptionId = null;
            }else{
              this.isVip = false;
              this.categoryOptionList = category[0].CourseCategoryOptionsList;
              let isExist = false;
              let option = this.categoryOptionList.filter(
                i =>
                  i.Id ==
                  newCourse
                    .CourseCategoryOptionId
              );
              if (option.length > 0) {
                isExist = true;
              }
              if (!isExist) {
                newCourse.CourseCategoryOptionId = this.categoryOptionList[0].Id;
              }
              newCourse.VipCoursePriceId = null;
            }
            
            this.changeCourseModel.IsNormalClass = false;
          }
        }
      }
      this.checkForNewCourseHourPrice();
    },
    getIsNormalClass(categoryId){
      return categoryId === this.GLOBAL.enumNormalCourseCategory.NormalClass 
          || categoryId === this.GLOBAL.enumNormalCourseCategory.OnlineCourse 
          || categoryId === this.GLOBAL.enumNormalCourseCategory.OMO
          || categoryId === this.GLOBAL.enumNormalCourseCategory.OfflineCourse;
    },
    onNewCourseCategoryOptionChanged() {
      this.checkForNewCourseHourPrice();
    },
    onNewCourseVipCoursePriceChange(){

    },
    onNewCourseCourseCountChange() {},
    onNewCourseMinutesChange(){},
    loadChangeCourseData() {
      if (
        this.dataIn.salesQueryRow.Id &&
        this.dataIn.salesQueryRow.TermId &&
        this.dataIn.salesQueryRow.StudentId
      ) {
        this.loading = true;
        getChangeCourseModel(
          this.dataIn.salesQueryRow.Id,
          this.dataIn.salesQueryRow.TermId,
          this.dataIn.salesQueryRow.StudentId
        ).then(result => {
          if (result && result.success) {
            this.changeCourseModel = result.data;
            
            this.selectedCourseId =
              this.changeCourseModel.NewCourseWorkflowCourse.CourseId == 0
                ? ""
                : this.changeCourseModel.NewCourseWorkflowCourse.CourseId;
            this.courseList = this.changeCourseModel.CourseList;
            this.getOriginalCourseName();
            this.excludeCourse();
            this.onNewCourseCategoryChanged();
            this.checkForNewCourseYearCourse();
            this.loadYearCourseTypeList();
            if (
              !!this.dataIn.week &&
              this.dataIn.week > 0 &&
              !!this.dataIn.supplementVideoType &&
              this.dataIn.supplementVideoType >= 0
            ) {
              let week = this.dataIn.week;
              if (this.isYearCourse && this.changeCourseModel.NewCourseWorkflowCourse.YearCourseType == 3){
                if (week <= 14){
                  week += 14;
                }
              }
              this.changeCourseModel.NewCourseWorkflowCourse.StartWeek = week;
              this.changeCourseModel.NewCourseWorkflowCourse.SupplementVideoType = this.dataIn.supplementVideoType;
              this.calculate();
            }
            this.isOnlineCourseVideoFree = this.changeCourseModel.NewCourseWorkflowCourse.SupplementVideoType === 5;
          }
          this.loading = false;
        });
      }
    },
    calculate() {
      if (this.isCalculated) {
        this.isCalculated = false;
        this.newPrice = "待计算";
        this.refundDetailVisible = false;
      } else {
        if (!this.isModelChanged()) {
          this.showError = true;
          this.errorMessage = "新旧课程相同，请选择不同的课程或不同的类型";
          return;
        } else {
          this.showError = false;
          this.errorMessage = "";
        }
        this.isCalculating = true;
        this.newPrice = "计算中，请稍候";
        calculateChangeCourseEnrollmentFee(this.changeCourseModel).then(
          result => {
            if (result && result.success) {
              this.changeCourseModel = result.data;
              this.isCalculated = true;
              this.newPrice = this.changeCourseModel.NewCourseWorkflowCourse.PaymentDiscountPrice;
              this.workflowRelatedDicountAmount = this.changeCourseModel.WorkflowRelatedDicountAmount;
              if (this.changeCourseType == 2){
                this.onShowRefundDetail();
              }else{
                this.isCalculating = false;
              }
            }else{
               this.isCalculating = false;
               if (!!result.message){
                 this.$message.error(result.message);
               }
            }
           
          }
        );
      }
    },
    saveCourse() {
      if (
        this.newCourseTotalPrice >
        this.changeCourseModel.OriginalCourseLeftMoney
      ) {
        if (this.changeCourseModel.NewCourseWorkflowCourse.CashDecreasedAmount < 0){
          this.$message.error("现金减不能为负!");
          return;
        }
        if (this.changeCourseModel.NewCourseWorkflowCourse.BonusPointCost < 0){
          this.$message.error("使用积分不能为负!");
          return;
        }
        
        if (this.finalPrice < 0) {
          this.$message.error("最终价格不能为负!");
          return;
        }
        if (
          this.changeCourseModel.NewCourseWorkflowCourse.BonusPointCost >
          this.memberModel.BonusPoint
        ) {
          this.$message.error("使用积分不能大于可用积分!");
          return;
        }
        this.changeCourseModel.NewCourseWorkflowCourse.BonusPointAmount = this.bonusPointAmount;
      } else {
        this.changeCourseModel.NewCourseWorkflowCourse.CashDecreasedAmount = 0;
        this.changeCourseModel.NewCourseWorkflowCourse.BonusPointCost = 0;
        this.changeCourseModel.NewCourseWorkflowCourse.BonusPointAmount = 0;
      }

      if (!this.memberModel.IsMember){
         this.changeCourseModel.NewCourseWorkflowCourse.BonusPointCost = 0;
         this.changeCourseModel.NewCourseWorkflowCourse.BonusPointAmount = 0;
      }

      if (!this.changeCourseModel.NewCourseWorkflowCourse.CashDecreasedAmount){
        this.changeCourseModel.NewCourseWorkflowCourse.CashDecreasedAmount = 0;
      }
      if (!this.changeCourseModel.NewCourseWorkflowCourse.BonusPointCost){
        this.changeCourseModel.NewCourseWorkflowCourse.BonusPointCost = 0;
      }
      if (!this.changeCourseModel.NewCourseWorkflowCourse.BonusPointAmount){
        this.changeCourseModel.NewCourseWorkflowCourse.BonusPointAmount = 0;
      }

      this.isSaving = true;
      this.$confirm("您是否确认按此差价结果进行换课?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          saveCourseChange(this.changeCourseModel).then(result => {
            if (!!result && result.success) {
              this.$message({
                type: "success",
                message: "课程更换成功!"
              });
              this.originalCourseName = this.courseList.filter(
                i => i.Id == this.selectedCourseId
              )[0].Name;
              this.Reset();
              this.$emit("saveCourseChangeSuccess");
            } else {
              this.Reset();
              this.$message({
                type: "error",
                message: "课程更换失败! " + result.message
              });
            }
            this.isSaving = false;
          });
        })
        .catch(() => {
          this.isSaving = false;
          this.Reset();
        });
    },
    onShowRefundDetail() {
      getRefundDetail(
        this.dataIn.salesQueryRow.Id,
        this.dataIn.salesQueryRow.WorkflowId,
        0,
        true
      ).then(result => {
        if (result && result.success) {
          this.refundDetailVisible = true;
  
          this.refundDetailModel = result.data;
          this.refundResult.RefundGiftBalance = 0;
          //1.减去已上课时后，课程节余金额
          let leftMoney =
            this.changeCourseModel.OriginalCourseLeftMoney -
            this.newCourseTotalPrice;
          let afterCashDecrease =
            leftMoney - this.refundDetailModel.CashDecreasedAmount;
          if (afterCashDecrease > 0){
            afterCashDecrease -= this.refundDetailModel.CouponDiscountDollar;
          }
          if (afterCashDecrease > 0){
            if (afterCashDecrease >= this.refundDetailModel.GiftBalanceCost){
              this.refundResult.RefundGiftBalance = this.refundDetailModel.GiftBalanceCost;
            }else{
              this.refundResult.RefundGiftBalance = afterCashDecrease;
            }
            afterCashDecrease -= this.refundDetailModel.GiftBalanceCost;
          }
          this.refundResult.RefundBalance = 0;
          this.refundResult.RefundOldBalance = 0;
          this.refundResult.RefundNewBalance = 0;
       
          this.refundResult.RefundOldBalanceTax = 0;
          this.refundResult.RefundNewBalanceTax = 0;
          this.refundResult.RefundGiftBalanceTax = 0;

          this.bonusPointIncrease = 0;
          this.bonusPointDescrease = 0;
          this.bonusPointDescreaseNotEnough = 0;
          this.bonusPointDescreaseNotEnoughPrice = 0;
          //2.减去现金减后，课程节余金额。如果<=0，那么无钱可退；如果>0，那么开始处理积分
          if (afterCashDecrease <= 0) {
            this.refundResult.RefundBonusPoint = 0;
            this.refundResult.RefundBalance = 0;
          } else {
            //3.减去积分抵扣后，课程节余金额。如果<=0，那么说明积分可以抵扣完节余金额，则退还节余金额对应的积分；如果>0，那么退还所有积分，且开始处理余额
            let afterBonusPointDecrease =
              afterCashDecrease - this.refundDetailModel.BonusPointAmount;

            if (afterBonusPointDecrease <= 0) {
              this.refundResult.RefundBonusPoint = Math.round(
                this.refundDetailModel.BonusPointCost *
                  (afterCashDecrease / this.refundDetailModel.BonusPointAmount)
              );
              this.refundResult.RefundBalance = 0;
              this.bonusPointIncrease = this.refundResult.RefundBonusPoint;
              this.bonusPointIncreaseAmount = this.getBonusPointAmount(this.bonusPointIncrease);
              this.bonusPointDescrease = 0;
            } else {
              this.refundResult.RefundBonusPoint = this.refundDetailModel.BonusPointCost;
              this.bonusPointIncrease = this.refundResult.RefundBonusPoint;
              this.bonusPointIncreaseAmount = this.getBonusPointAmount(this.bonusPointIncrease);
              this.bonusPointDescrease = 0;
              //4.实付金额=现金/转帐+余额支付+占位支付, 如果实付金额<=课程节余金额,那么最多只能退实付金额到余额；否则退课程节余金额到余额。
              let paidSum =
                this.refundDetailModel.IncomeInFact +
                this.refundDetailModel.BalanceCost +
                this.refundDetailModel.AdvanceEnrollmentCost;
              if (paidSum > 0) {
                this.refundResult.RefundBalance =
                  paidSum <= afterBonusPointDecrease
                    ? paidSum
                    : afterBonusPointDecrease;
                //5.如果要退余额，计算应退的新余额和旧余额
                if (
                  this.refundDetailModel.OldBalanceCost >=
                  this.refundResult.RefundBalance
                ) {
                  this.refundResult.RefundNewBalance = 0;
                  this.refundResult.RefundOldBalance = this.refundResult.RefundBalance;
                } else {
                  this.refundResult.RefundOldBalance = this.refundDetailModel.OldBalanceCost;
                  this.refundResult.RefundNewBalance =
                    this.refundResult.RefundBalance -
                    this.refundResult.RefundOldBalance;
                  //6. 如果要退新余额，扣除对应积分
                  if (this.refundDetailModel.IsDecreaseBonusPoint) {
                    let bonusPoint = parseInt(
                      (this.refundResult.RefundNewBalance *
                        this.moneyToBonusPoint.BonusPoint) /
                        this.moneyToBonusPoint.Money
                    );

                    if (this.refundDetailModel.CourseBonusPointRate != 1) {
                      bonusPoint =
                        bonusPoint *
                        this.refundDetailModel.CourseBonusPointRate;
                    }

                    this.refundResult.RefundBonusPoint -= bonusPoint;
                    this.bonusPointDescrease = bonusPoint;

                    //判断学生积分是否足够，如果积分不足，扣除余额
                    if (
                      this.refundResult.RefundBonusPoint < 0 &&
                      this.refundDetailModel.StudentBonusPoint +
                        this.refundResult.RefundBonusPoint <
                        0
                    ) {
                      let bonusPointDiff =
                        (this.refundDetailModel.StudentBonusPoint +
                          this.refundResult.RefundBonusPoint) *
                        -1;
                      this.refundResult.RefundBonusPoint =
                        this.refundDetailModel.StudentBonusPoint * -1;
                      this.bonusPointDescrease =
                        this.refundDetailModel.StudentBonusPoint +
                        this.bonusPointIncrease;
                      let balance =
                        (bonusPointDiff * this.bonusPointToMoney.Money) /
                        this.bonusPointToMoney.BonusPoint;

                      this.bonusPointDescreaseNotEnough = bonusPointDiff;
                      this.bonusPointDescreaseNotEnoughPrice = balance;

                      this.refundResult.RefundNewBalance -= balance;
                      if (this.refundResult.RefundNewBalance < 0) {
                        this.refundResult.RefundOldBalance += this.refundResult.RefundNewBalance;
                        this.refundResult.RefundNewBalance = 0;
                        if (this.refundResult.RefundOldBalance < 0) {
                          this.refundResult.RefundOldBalance = 0;
                        }
                      }
                      this.refundResult.RefundBalance =
                        this.refundResult.RefundOldBalance +
                        this.refundResult.RefundNewBalance;
                    }
                  }
                }
              } else {
                this.refundResult.RefundBalance = 0;
              }

              if (this.changeCourseModel.HasTax){
                this.refundResult.RefundOldBalanceTax = this.refundResult.RefundOldBalance * this.changeCourseModel.TaxRate;
                this.refundResult.RefundNewBalanceTax = this.refundResult.RefundNewBalance * this.changeCourseModel.TaxRate;
                this.refundResult.RefundGiftBalanceTax = this.refundResult.RefundGiftBalance * this.changeCourseModel.TaxRate;
              }
             
            }
          }
        }
        this.isCalculating = false;
      });
    },
    getBonusPointAmount(value){
      return toDecimal(value * this.bonusPointToMoney.Money /
        this.bonusPointToMoney.BonusPoint);               
    },
    onYearCourseTypeChange(){
      this.loadYearCourseWeekList(true);
    },
    onStartWeekChange() {
      if (this.changeCourseModel.NewCourseWorkflowCourse.StartWeek > 2) {
        this.isShowAfterWeek2 = true;
      } else {
        this.isShowAfterWeek2 = false;
        this.changeCourseModel.SignedInTimeLength = 0;
      }
    },
    isModelChanged() {
      let newCourse = this.changeCourseModel.NewCourseWorkflowCourse;
      let oldCourse = this.changeCourseModel.OriginalWorkflowCourse;
      if (
        newCourse.CourseId === oldCourse.CourseId &&
        newCourse.CourseCategoryId === oldCourse.CourseCategoryId &&
        newCourse.CourseCategoryOptionId === oldCourse.CourseCategoryOptionId &&
        newCourse.VipCoursePriceId === oldCourse.VipCoursePriceId &&
        newCourse.CourseCount === oldCourse.CourseCount &&
        newCourse.CourseMinutes === oldCourse.CourseMinutes &&
        newCourse.SupplementVideoType === oldCourse.SupplementVideoType &&
        newCourse.YearCourseType === oldCourse.YearCourseType
      ) {
        return false;
      }
      return true;
    },
    cancelSave() {
      this.isSaving = false;
      this.Reset();
      this.$emit("closeChangeCourseEditor");
    },
    Reset() {
      this.init();
      this.isCalculated = false;
      this.refundDetailVisible = false;
      this.showError = false;
      this.errorMessage = "";
    },
    onOnlineCourseVideoFreeChange(){
      if (this.isOnlineCourseVideoFree) {
        this.changeCourseModel.NewCourseWorkflowCourse.SupplementVideoType = 5;
      } else {
        this.changeCourseModel.NewCourseWorkflowCourse.SupplementVideoType = 0;
      }
    }
  },
  watch: {
    selectedCourseId: function() {
      this.changeCourseModel.NewCourseWorkflowCourse.CourseId = this.selectedCourseId;
    },
    dataIn: function() {
      this.Reset();
    },
    status: function() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/changeCourseEditor.vue